<template>
  <div class="new-fast--container">
    <div class="new-fast--staff-line shadow-card mrg-t-10">
      <div class="new-fast--staff">
        <div class="input-block">
          <label for="staff">Сотрудник</label>
          <select id="staff" v-model="staffModel">
            <option
              v-for="(staffList, index) in staffList"
              :key="index"
              v-bind:value="staffList.id"
              >{{ staffList.name }}</option
            >
          </select>
        </div>
      </div>
      <div class="new-fast--date">
        <div class="input-block">
          <label>Дата</label>
          <DatePicker
            v-model="dateModel"
            :value="dateModel"
            :active="activeDaysPicker"
          ></DatePicker>
        </div>
      </div>
    </div>
    <!-- -->
    <div class="new-fast--services-line shadow-card mrg-t-20">
      <div class="text-bold text-center">Выберите услугу</div>
      <fast-services
        class="mrg-t-10"
        @addService="addService"
        :list="fastServices"
        :reset="resetFastServices"
      ></fast-services>
      <div v-if="servicesModel.length" class="text-bold text-center mrg-t-10">Список выбранных услуг</div>
      <div class="new-fast--services-list mrg-t-15">
        <div
          v-if="servicesModel.length"
          class="item new-fast--services-item-title"
        >
          <div class="name">Название</div>
          <div class="duration">Продолжительность</div>
          <div class="price">Стоимость</div>
          <div class="actions"></div>
        </div>
        <div class="item new-fast--services-item-item" v-for="item in servicesModel" :key="item.service_id +'_' +item.modification_id">
          <div class="name"><b>({{item.category_name}})</b> {{ item.name }}</div>
          <div class="duration">
            <div class="input-block mb-0">
              <div class="duration-flex">
                <div>
                  <select v-model="item.time_hour">
                    <option
                      v-for="(hour, index) in hourArray"
                      :key="index"
                      :value="hour"
                      >{{ hour }}</option
                    >
                  </select>
                </div>
                <div>:</div>
                <div>
                  <select v-model="item.time_minute">
                    <option
                      v-for="(minute, index) in minuteArray"
                      :key="index"
                      :value="minute"
                      >{{ minute }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="price">
            <div class="input-block mb-0">
              <input v-model="item.price" />
            </div>
          </div>
          <div class="actions">
            <div
              @click="deleteService(item.service_id, item.modification_id)"
              class="btn btn-sm btn-outline-danger"
            >
              <f-awesome icon="times"></f-awesome>
            </div>
          </div>
        </div>
        <div v-show="fullPrice > 0" class="item new-fast--services-item-item full-price">
          <div class="name"></div>
          <div class="duration"></div>
          <div class="price">
            <div class="mrg-t-10">
              Итого: <b>{{fullPrice}}</b>
            </div>
          </div>
          <div class="actions"></div>
        </div>
        <div
          class="item new-fast--services-item-item minimal_enroll_sum text-orange"
          v-show="fullPrice > 0"
        >
          {{minimalEnrollSumText}}
        </div>
      </div>
    </div>

    <div v-if="+is_group === 1" class="shadow-card mrg-t-20">
      <div class="text-bold text-center">Настройки групповой записи</div>
      <div class="new-fast--group-setting mrg-t-15">
        <div class="input-block">
          <label for="groupSetting_participants_count">
            Максимальное кол-во участников в групповой записи
          </label
          >
          <select v-model="groupSetting.participants_count" id="groupSetting_participants_count">
            <option
              v-for="(item, index) in participantsOptionsComputed"
              :key="index"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
        </div>
        <div class="input-block">
          <label for="groupSetting_show_seats_left">
            <input
                type="checkbox"
                v-model="groupSetting.show_seats_left"
                id="groupSetting_show_seats_left"
            />
            Показывать кол-во занятых и свободных мест клиенту при онлайн записи
          </label>
        </div>
        <div class="input-block">
          <label for="groupSetting_notifications_new">
            <input
                type="checkbox"
                v-model="groupSetting.notifications_new"
                id="groupSetting_notifications_new"
            />
            Отправлять <span class="text-bold">уведомления</span>
            новым клиентам о записи согласно настройкам
          </label>
          <div class="hint">
            Данная настройка перекрывает стандартные настройки уведомлений (раздел Настройки -> Уведомления)
            для большей гибкости,
            т.к для групповой записи может не понадобиться отправка уведомлений.
          </div>
        </div>
      </div>
    </div>

    <!-- -->
    <div class="shadow-card mrg-t-20">
      <div class="text-bold text-center">Время записи</div>
      <div class="new-fast--intervals-line mrg-t-15">
        <div class="new-fast--load-intervals">
          <div class="input-block">
            <div
              @click="showWindows"
              class="btn btn-sm btn-info form-line"
            >
              <f-awesome icon="sync"></f-awesome>
              Обновить
            </div>
          </div>
        </div>
        <div class="new-fast--intervals">
          <div class="input-block">
            <label for="time">Время</label>
            <select id="time" v-model="timeModel">
              <option
                v-for="item in timeIntervals"
                :key="item.from"
                :value="item.from"
                >{{ minuteToTime(item.from) }}</option
              >
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- -->
    <div class="new-fast--client-line shadow-card mrg-t-20">
      <div class="text-bold text-center mrg-t-10">Клиент (-ы)</div>
      <div v-if="is_group === 1 && mode == 'new' && loadEnrollId == 0" class="text-hint text-center">
        При создании групповой записи, вы можете не добавлять ни одного клиента
      </div>
      <div v-if="+is_group === 0" class="mrg-t-10">
        <fast-client
          v-model="enrollClientsModel"
          :enrollClients="enrollClients"
          :fullConfig="fullConfig"
          :reset="resetSearchClient"
          :is_canceled="isCanceledForFastClient"
          @clickManualSms="clickManualSms"
        ></fast-client>

      </div>
      <div v-if="+is_group === 1" class="mrg-t-10">
        <div class="text-center fs-16 text-underline">
          В данный момент записано
          <span class="text-bold fs-17">{{ activeEnrollClient }}</span> из
          <span class="text-bold fs-17">{{ groupSetting.participants_count }}</span>
          клиентов
        </div>
        <div class="mrg-t-10 text-center">
          <div @click="showManageGroupClientPopup" class="btn btn-sm btn-info">
            Управлять списком клиентов
          </div>
          <div @click="printGroupClient" class="btn btn-sm btn-outline-info">
            <f-awesome icon="print"></f-awesome> Печать
          </div>
        </div>
      </div>
    </div>

    <div class="new-fast--comments-line shadow-card mrg-t-20">
      <div class="text-bold text-center">Комментарий к записи</div>
      <div class="new-fast--comment-admin mrg-t-10">
        <label class="text-bold" for="add_enroll_comment">Ваш комментарий</label>
        <div class="input-block">
          <textarea
            type="text"
            rows="3"
            v-model="enrollComment"
            @blur="vCommentCompany"
            id="add_enroll_comment"
          ></textarea>
          <div class="form-error">{{ formError.enrollComment }}</div>
        </div>
      </div>
    </div>

    <!-- Статус записи -->
    <div class="new-fast--confirm-line shadow-card mrg-t-20">
        <div class="text-bold text-center">Статус записи</div>
        <div class="new-fast--status-flex mrg-t-10">
          <div  @click="enrollConfirm = 0" class="item" :class="{'active': enrollConfirm == 0}">
            <div class="name">Новая</div>
            <div class="color">
              <div class="circle-status circle-status-new"></div>
            </div>
          </div>
          <div @click="enrollConfirm = 1" class="item" :class="{'active': enrollConfirm == 1}">
            <div class="name">Подтвержденная</div>
            <div class="color">
              <div class="circle-status circle-status-confirm"></div>
            </div>
          </div>
          <div @click="enrollConfirm = 2" class="item" :class="{'active': enrollConfirm == 2}">
            <div class="name">Выполненная</div>
            <div class="color">
              <div class="circle-status circle-status-done"></div>
            </div>
          </div>
          <div @click="enrollConfirm = 3" class="item" :class="{'active': enrollConfirm == 3}">
            <div class="name">Отмененная</div>
            <div class="color">
              <div class="circle-status circle-status-cancel"></div>
            </div>
          </div>
        </div>
    </div>

    <!-- Автоматические напоминания о записи -->
    <div
        v-if="fullConfig.main_config && fullConfig.main_config.remind_before_setting > 0"
        class="new-fast--auto-remind shadow-card mrg-t-20"
    >
      <div class="text-bold text-center">Автонапоминания</div>
      <auto-reminders
          :remind-setting="fullConfig.main_config.remind_before_setting"
          :enroll-val="remindHourSetter"
          :is-new-enroll="isNewEnroll"
          @change="selectRemindHour"
      ></auto-reminders>
    </div>

    <!-- ================ Источник привлечения  =============-->
    <div class="shadow-card mrg-t-20">
      <div class="text-bold text-center">Источник привлечения</div>
      <div class="input-block mrg-t-10">
        <select :disabled="!checkPermission('edit_source_client')" v-model="source_client_id" :id="'client_source'">
          <option value="0">Не выбран</option>
          <option v-for="item in sourceClient" :key="item.id" :value="item.id">
            {{item.name}}
          </option>
        </select>
        <div
            v-if="checkPermission('create_source_client') || checkPermission('delete_source_client')"
            @click="showAddSourcePopup"
            class="add-source text-center mrg-t-10"
          >
            Управление источниками
        </div>
      </div>
    </div>
    <!-- ====================== END Источник привлечения  ==================-->
    <div
      v-if="
        mode == 'new' &&
        loadEnrollId == 0 &&
        +is_group === 0 &&
        (fullConfig.main_config && fullConfig.main_config.sms_client_enroll == 1 )
      "
      class="new-fast--others-line shadow-card mrg-t-20"
    >
      <div class="text-bold text-center">
        Оповещение о создании записи
      </div>

      <div class="mrg-t-10">
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="sendSms" />
            Отправить клиенту <b>СМС</b>
          </label>
        </div>
        <div class="hint">
          По умолчанию, если вы создаете запись самостоятельно, СМС не отправляется.
          Необходимо проставить данную галочку, чтобы оно было отправлено.
        </div>
      </div>
    </div>

    <div
      v-if="
        mode == 'edit' && loadEnrollId > 0 && +is_group === 0 &&
        (
          (fullConfig.main_config && fullConfig.main_config.sms_client_enroll == 1 ) ||
          (
            fullConfig.main_config && fullConfig.main_config.telegram_client_enroll == 1 && fullConfig.computed.exists_user_tg_bot &&
            enrollClientsModel.length > 0 && enrollClientsModel[0].clients && enrollClientsModel[0].clients.tgChatId
          ) ||
          (fullConfig.main_config && fullConfig.main_config.whatsapp_client_enroll == 1 && fullConfig.main_config.pushsms_token && fullConfig.main_config.pushsms_token.length > 20) ||
          (enrollClientsModel.length > 0 && enrollClientsModel[0].clients && enrollClientsModel[0].clients.email && enrollClientsModel[0].clients.email.length > 1)
        )
      "
      class="new-fast--others-line shadow-card mrg-t-20"
    >
      <div class="text-bold text-center">
        Отправить оповещение об изменении
      </div>
      <!-- clientBindTgBot -->
      <div class="mrg-t-10">
        <div
          v-if="fullConfig.main_config && fullConfig.main_config.telegram_client_enroll == 1 && fullConfig.computed.exists_user_tg_bot &&
            enrollClientsModel.length > 0 && enrollClientsModel[0] && enrollClientsModel[0].clients &&
            enrollClientsModel[0].clients.tgChatId"
          class="input-block">
          <label>
            <input type="checkbox" v-model="sendTelegram" />
            Отправить клиенту сообщение в <b>Telegram</b>
          </label>
        </div>
        <div v-if="fullConfig.main_config && fullConfig.main_config.sms_client_enroll == 1" class="input-block">
          <label>
            <input type="checkbox" v-model="sendSms" />
            Отправить клиенту <b>СМС</b>
          </label>
        </div>
        <div
          v-if="fullConfig.main_config && fullConfig.main_config.whatsapp_client_enroll == 1 && fullConfig.main_config.pushsms_token && fullConfig.main_config.pushsms_token.length > 20"
          class="input-block"
        >
          <label>
            <input type="checkbox" v-model="sendWhatsapp" />
            Отправить клиенту сообщение в <b>WhatsApp</b>
          </label>
        </div>
        <div v-if="enrollClientsModel.length && enrollClientsModel[0].clients && enrollClientsModel[0].clients.email &&
            enrollClientsModel[0].clients.email.length > 1"
          class="input-block">
          <label>
            <input type="checkbox" v-model="sendEmail" />
            Отправить клиенту <b>E-mail</b>
          </label>
        </div>
      </div>
    </div>

    <!-- Оповещение об изменении для групповых -->
    <div
      class="new-fast--others-line shadow-card mrg-t-20"
      v-if="mode == 'edit' && loadEnrollId > 0 && +is_group === 1"
    >
      <div class="text-bold text-center">
        Отправить оповещение об изменении
      </div>
      <div class="mrg-t-10">
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="send_edit_notify_group" />
            Отправить записанным участникам уведомление об изменении записи согласно настройкам оповещения
          </label>
          <div class="hint">
            Данная настройка влияет только на уже записанных клиентов. Уведомления для новых
            придут согласно настройкам групповой записи (чуть выше) и основным настройкам уведомлений
            (раздел Настройки -> Уведомления)
          </div>
        </div>
      </div>
    </div>


    <div class="new-fast--history mrg-t-20">
      <enroll-history :list="enrollHistory"></enroll-history>
    </div>

    <div class="new-fast--actions mrg-t-20">
      <div
        v-if="
          enrollClientsModel.length > 0 &&
          enrollClientsModel[0] &&
          enrollClientsModel[0].clients &&
          loadEnrollId > 0
        "
        class="input-block"
      >
          <a
              class="btn btn-sm btn-outline-info"
              :href="googleCalendarLink"
              target="_blank" rel="nofollow">
            В Google-календарь
          </a>
      </div>
      <div class="input-block">
        <div
          v-if="checkPermission('delete_enroll') && mode == 'edit'"
          @click="deleteEnroll"
          class="btn btn-sm btn-danger mrg-t-10"
        >
          Удалить запись
        </div>
        <div
            v-if="permSaveButton"
            @click="saveEnroll(false)"
            class="btn btn-sm btn-success mrg-t-10"
        >
          Сохранить
        </div>
        <div
            v-if="permSaveButton"
            @click="saveEnroll(true)"
            class="btn btn-sm btn-success mrg-t-10"
        >
          Сохранить и свернуть
        </div>
      </div>
    </div>

    <popup
      :closeButton="deleteEnrollPopup.closeButton"
      :actionButton="deleteEnrollPopup.actionButton"
      :actionClass="deleteEnrollPopup.actionClass"
      :show="deleteEnrollPopup.show"
      @closePopup="closeDeleteEnrollPopup"
      @actionPopup="deleteEnrollSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Запись будет удалена без возможности восстановления
      </div>
    </popup>

    <popup
      :closeButton="addSourcePopup.closeButton"
      :show="addSourcePopup.show"
      @closePopup="closeAddSourcePopup"
    >
      <div slot="header">Управление источниками привлечения</div>
      <div slot="body">
        <crud-source-client
          v-if="addSourcePopup.show"
          @updateSource="updateSourceClient"
        ></crud-source-client>
      </div>
    </popup>

    <popup
      :closeButton="manageGroupClientPopup.closeButton"
      :show="manageGroupClientPopup.show"
      :size="'lg'"
      @closePopup="closeManageGroupClientPopup"
    >
      <div slot="header">Управление списком клиентов групповой записи</div>
      <div slot="body">
        <div class="alert alert-sm alert-success">
          При изменении списка, не забудьте сохранить запись
        </div>
        <div>
          <fast-clients-group
            v-model="enrollClientsModel"
            :enrollClients="enrollClients"
            :fullConfig="fullConfig"
            :is_group="+is_group"
            :groupSetting="groupSetting"
            :reset="resetSearchClient"
            @clickManualSms="clickManualSms"
          ></fast-clients-group>
        </div>
      </div>
    </popup>


    <popup
      :closeButton="printGroupClientsPopup.closeButton"
      :show="printGroupClientsPopup.show"
      @closePopup="closePrintGroupClient"
    >
      <div slot="header">Скачайте .docx файл со списком клиентов</div>
      <div slot="body">
        <div v-if="printGroupClientsLink" class="mrg-t-20 alert alert-sm alert-success">
          <p>Файл сгенерирован! Ссылка для скачивания: </p>
          <p>
            <a
              style="font-weight: 700;
              text-decoration: underline"
              :href="printGroupClientsLink"
            >
              {{printGroupClientsLink}}
            </a>
          </p>
        </div>
      </div>
    </popup>


  </div>
</template>

<script>

import DatePicker from "../../../DatePicker";
import FastServices from "./FastServices";
import Formatter from "../../../libraries/Formatter";
import SearchClient from "../../clients/SearchClient";
import Popup from "@/components/Popup";
import permissionMixin from "@/components/mixins/Permissions";
import InfoClient from "@/components/panel/clients/InfoClient";
import Validator from "@/components/libraries/Validator";
import AutoReminders from "@/components/panel/journal/AutoReminders";
import EnrollHistory from "@/components/panel/journal/fast_new/EnrollHistory";
import CrudSourceClient from '../../source_client/CrudSourceClient.vue';
import FastClient from '@/components/panel/journal/fast_new/FastClient.vue';
import FastClientsGroup from '@/components/panel/journal/fast_new/FastClientsGroup.vue';
import enrollRepository from "../../../../repositories/enroll";
import websocketEventBus from "../../../../eventBus/websocketEventBus";
import journalRepository from "../../../../repositories/journal";
import configRepository from "../../../../repositories/config";
import sourceRepository from "../../../../repositories/source";
import staffRepository from "../../../../repositories/staff";

const formatter = new Formatter();
const validator = new Validator();

export default {
  name: "FastNew",
  components: {
    EnrollHistory, AutoReminders, InfoClient, Popup, SearchClient,
    FastServices, DatePicker, CrudSourceClient, FastClient, FastClientsGroup,

  },
  mixins: [permissionMixin],
  data() {
    return {
      hourArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      minuteArray: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      is_group: 0, // model
      enrollConfirm: 1, // model
      staffModel: "", // model
      staffEnroll: "", // какому сотруднику принадлежит запись, чтобы формировать матрицу оказываемых услуг
      servicesModel: [], // model
      remindHourModel: 0, // model
      remindHourSetter: 0,
      enrollComment: "", // model
      //clientComment: "",
      clientModel: null, // model
      enrollClientsModel: [], // model
      enrollClients: [], // model
      clientBindTgBot: false, // Привязан ли к телеграм-боту пользователя
      dateModel: "", // model
      timeModel: "", // model
      sendSms: false, // model
      sendTelegram: false, // model
      sendWhatsapp: false, // model
      sendEmail: false, // model
      sendEmailMe: false, // model
      //block_sms_if_new: false, // model
      //addField: "", // model,
      source_client_id: 0, // model
      //click_manual_sms: 0, // model
      send_edit_notify_group: 0, // model
      groupSetting: {
        participants_count: 2,
        show_seats_left: 0,
        notifications_new: 0
      },
      manual_sms_text: '',
      source_client_enroll: null,
      enrollHistory: [],
      date_google_from: '',
      date_google_to: '',
      timeIntervals: [],
      resetFastServices: 0,
      searchClientSelected: null,
      resetSearchClient: 0,
      formError: {
        enrollComment: ''
      },
      fullData: {
        staff: []
      },
      fullConfig: {},
      deleteEnrollPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      manageGroupClientPopup: {
        show: false,
        closeButton: "Закрыть",
        actionClass: "btn-success"
      },
      sourceClient: [],
      addSourcePopup: {
        show: false,
        closeButton: "Отмена"
      },
      printGroupClientsPopup: {
        show: false,
        closeButton: "Отмена"
      },
      printGroupClientsLink: ''
    };
  },
  props: {
    defaultDate: String,
    show: Boolean,
    mode: String, // Режим открытия: new/edit для того, чтобы понимать, по какому сценарию работать
    staffId: Number,
    wantTime: Number, // Желаемое время записи. Если в свободных интервалах такое есть, то будет прописано в timeModel
    loadEnrollId: Number // ID записи, которую нужно загрузить/ 0 - сбросить компонент, number - загрузить запись
  },
  watch: {
    sendSms: function (val) {
      localStorage.setItem('sendSmsFastNew', val === true ? 'true' : 'false');
    },
    fullConfig: {
      handler (val) {
        if (
            val && val.main_config &&
            val.main_config.sms_client_enroll == 1 &&
            +this.is_group === 0
        ) {
          const sendSmsFastNewStorage = localStorage.getItem('sendSmsFastNew');
          if(sendSmsFastNewStorage !== null){
            this.sendSms = sendSmsFastNewStorage === 'true';
          }
        }
      },
      deep: true
    },
    loadEnrollId: function(val) {
      if (val === 0) {
        this.resetComponent();
        this.staffModel = this.staffId;
      } else {
        this.resetComponent();
        this.loadEnroll(val);
      }
    },
    dateModel: function() {
      this.timeIntervals = [];
      this.timeModel = "";
    },
    defaultDate: function(val) {
      this.dateModel = val;
    },
    show: function(val) {
      if (val && !this.sourceClient.length) {
        this.getSources();
      }
      if (val && !this.fullData.staff.length) {
        this.getStaffData();
      }
      if(val && !this.fullConfig.main_config){
        this.getFullConfig();
      }
      if (val) {
        this.dateModel = this.defaultDate;
        this.staffModel = this.staffId;
      }
    },
    staffId: function(val) {
      this.staffModel = val;
    },
    // При изменении делаем сброс компонента fast-services
    staffModel: function() {
      this.resetFastServices++;
    }
  },
  computed: {
    isNewEnroll(){
      let result = false;
      if(this.mode == 'new' && this.loadEnrollId == 0){
        result = true;
      }
      return result;
    },
    isCanceledForFastClient(){
      return +this.enrollConfirm === 3 ? 1 : 0
    },
    // isGroupEnroll(){
    //   let result = false;
    //   for (let key in this.servicesModel) {
    //     if(+this.servicesModel[key].is_group === 1){
    //       result = true;
    //     }
    //   }
    //   return result;
    // },
    participantsOptionsComputed(){
      let result = [];
      for(let i = 2; i <= 100; i++){
        result[result.length] = i;
      }
      return result;
    },
    activeEnrollClient(){
      let result = 0;
      for(let key in this.enrollClientsModel){
        if(+this.enrollClientsModel[key].is_canceled === 0){
            if(this.enrollClientsModel[key].clients){
              result++;
            }
          }
      }
      return result;
    },
    googleCalendarLink(){
      //enrollClientsModel.length > 0 && enrollClientsModel[0]
      let result = 'http://www.google.com/calendar/event?action=TEMPLATE&text=';
      if(+this.is_group === 1){
        result += "Групповая онлайн запись";
      }else{
        result += 'Онлайн запись. Клиент: ' +this.enrollClientsModel[0].clients.name;
        if(this.enrollClientsModel[0].clients.surname){
          result += ' ' +this.enrollClientsModel[0].clients.surname;
        }
      }

      result += '&dates=' +this.date_google_from +'/' +
          this.date_google_to;

      return result;
    },
    permSaveButton(){
      let result = false;
      if(this.mode == 'new'){
        result = this.checkPermission('create_enroll');
      }else if(this.mode == 'edit'){
        result = this.checkPermission('update_enroll');
      }
      return result;
    },
    activeDaysPicker() {
      let result = [];

      if (this.staffModel != "" && this.fullData.staff.length) {
        for (let key in this.fullData.staff) {
          if (+this.fullData.staff[key].id === +this.staffModel) {
            result = this.fullData.staff[key].active_days;
          }
        }
      }
      return result;
    },
    computedWantTime() {
      let result = 0;
      if (this.defaultDate == this.dateModel) {
        result = this.defaultDate;
      }
      return result;
    },
    staffList() {
      let result = [];
      if (this.servicesModel.length) {
        // сформируем лист выбранных услуг
        let selectedServices = [];
        let selectedModifications = [];

        for (let key in this.servicesModel) {
          if(+this.servicesModel[key].modification_id > 0){
            selectedModifications[selectedModifications.length] = this.servicesModel[key].modification_id;
          }else{
            selectedServices[selectedServices.length] = this.servicesModel[key].service_id;
          }
        }

        for (let staff in this.fullData.staff) {
          let includeStaff = true;
          for (let servModel in this.servicesModel) {
            // Если услуга уже стоит в записи, значит сотрудник как минимум мог ее оказывать
            if(
                this.mode == 'edit' &&
                +this.fullData.staff[staff].id === +this.staffEnroll &&
                this.servicesModel[servModel].addPlace == 'server'
            ){
              continue;
            }
            let existsServOrModif = false;
            for (let sts in this.fullData.staff[staff].staffToServices) {
              if(+this.servicesModel[servModel].modification_id > 0){
                if(+this.servicesModel[servModel].modification_id === +this.fullData.staff[staff].staffToServices[sts].modification_id){
                  existsServOrModif = true;
                }
              }else{
                if(+this.servicesModel[servModel].service_id === +this.fullData.staff[staff].staffToServices[sts].service_id){
                  existsServOrModif = true;
                }
              }
            }
            if(!existsServOrModif){
              includeStaff = false;
            }
          }
          if(includeStaff){
            result.push(this.fullData.staff[staff])
          }
        }
      } else {
        result = this.fullData.staff;
      }
      return result;
    },
    fastServices() {
      let result = [];
      if (this.staffModel !== "") {
        for (let key in this.fullData.staff) {
          if (+this.fullData.staff[key].id === +this.staffModel) {
            result = this.fullData.staff[key].staffToServices;
          }
        }
      }
      return result;
    },
    servicesDurationMinute() {
      let duration = 0;
      for (let key in this.servicesModel) {
        duration += formatter.hourMinuteToMinute(
          this.servicesModel[key].time_hour,
          this.servicesModel[key].time_minute
        );
      }
      return duration;
    },
    fullPrice(){
      let price = 0;
      for (let key in this.servicesModel) {
        price += parseFloat(this.servicesModel[key].price);
      }
      if(+this.is_group === 1){
        price = price * this.activeEnrollClient;
      }
      return price;
    },
    minimalEnrollSumText(){
      let result = '';
      if(
        this.fullConfig &&
        this.fullConfig.company_config &&
        +this.fullConfig.company_config.use_minimal_enroll_sum === 1 &&
        this.fullPrice < +this.fullConfig.company_config.minimal_enroll_sum
      ){
        result = 'Минимальная сумма записи: ' +this.fullConfig.company_config.minimal_enroll_sum;
      }
      return result;
    },
    validateCommentCompany() {
      let errorCount = 0;
      this.vCommentCompany().result == "error" ? errorCount++ : "";

      return errorCount;
    },
    selectedServices() {
      const result = [];
      for(let servKey in this.servicesModel){
        const item = {
          service_id: this.servicesModel[servKey]['service_id'],
          modification_id: this.servicesModel[servKey]['modification_id'],
        };
        result.push(item);
      }
      return result;
    }
  },
  methods: {
    closePrintGroupClient(){
      this.printGroupClientsLink = '';
      this.printGroupClientsPopup.show = false;
    },
    printGroupClient(){
      journalRepository.printGroupClients({ enroll_id:  this.loadEnrollId}).then(resp => {
        this.printGroupClientsLink = resp.data.link;
        this.printGroupClientsPopup.show = true;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    showManageGroupClientPopup(){
      this.manageGroupClientPopup.show = true;
    },
    closeManageGroupClientPopup(){
      this.manageGroupClientPopup.show = false;
    },
    clickManualSms(number){
      window.open('sms:+' + number + '?&body=' +this.manual_sms_text);
    },
    getSources(){
      sourceRepository.view().then(resp => {
        this.sourceClient = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    updateSourceClient(val){
      this.sourceClient = val;
    },
    showAddSourcePopup(){
      this.addSourcePopup.show = true;
    },
    closeAddSourcePopup(){
      this.addSourcePopup.show = false;
    },
    copyText(text){
      navigator.clipboard.writeText('+' +text)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: 'Номер скопирован в буфер обмена',
              time: 3,
              color: "success"
            });
          })
          .catch(() => {
            this.$store.dispatch("addNotification", {
              text: 'Ваш браузер не поддерживает копирование',
              time: 3,
              color: "danger"
            });
          });
    },
    vCommentCompany(){
      let validate = validator.validate([
        {
          fieldName: "Ваш комментарий",
          value: this.enrollComment,
          type: "string",
          length: 450
        },
      ]);
      validate.result == "error"
          ? (this.formError.enrollComment = validate.message)
          : (this.formError.enrollComment = "");
      return validate;
    },
    selectRemindHour(value){
      this.remindHourModel = value;
    },
    closeDeleteEnrollPopup() {
      this.deleteEnrollPopup.show = false;
    },
    deleteEnrollSubmit() {
      this.$store.dispatch("startPreloader");

      enrollRepository.deleteById({
        'id': this.loadEnrollId
      }).then(resp => {
        if (resp.data.result === "ok") {
          this.$emit("closeAndUpdate");
          this.closeDeleteEnrollPopup();
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    deleteEnroll() {
      this.deleteEnrollPopup.show = true;
    },
    resetComponent() {
      this.is_group = 0;
      this.timeIntervals = [];
      this.timeModel = "";
      this.clientModel = null;
      this.enrollClientsModel = [];
      this.enrollClients = [];
      this.resetSearchClient++;
      this.staffModel = "";
      this.servicesModel = [];
      this.enrollComment = "";
      //this.clientComment = "";
      this.enrollConfirm = 1;
      //this.sendSms = false;
      this.sendTelegram = false;
      //this.block_sms_if_new = false;
      this.sendWhatsapp = false;
      this.sendEmail = false;
      //this.addField = "";
      this.enrollHistory = [];
      this.source_client_id = 0;
      this.groupSetting.participants_count = 2;
      this.groupSetting.show_seats_left = 0;
      this.groupSetting.notifications_new = 0;
      //this.click_manual_sms = 0;
    },
    minuteToTime(minute) {
      return formatter.minuteToTime(minute);
    },
    getFullConfig(){
      configRepository.fullConfigCurrentCompany().then(resp => {
        this.fullConfig = resp.data.result;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    addService(val) {
      // Выполняем проверки, есть ли уже в списке такая услуга
      // При каждом добавлении проверяем какие сотрудники могут оказывать данный список и удаляем сотрудников, если кто-то не может
      for (let key in this.servicesModel) {
        if (+this.servicesModel[key].service_id === +val.service_id && +this.servicesModel[key].modification_id === +val.modification_id) {
          this.$store.dispatch("addNotification", {
            text: "Услуга уже есть в списке",
            time: 3,
            color: "danger"
          });
          return false;
        }
      }
      // Проверим. Если у нас уже есть групповая услуга, значит больше не можем добавлять услуги
      for (let key in this.servicesModel) {
        if(+this.servicesModel[key].is_group === 1){
          this.$store.dispatch("addNotification", {
            text: "В групповой записи может быть только 1 услуга",
            time: 3,
            color: "danger"
          });
          return false;
        }
      }
      // Проверим. Если есть обычная услуга, то нельзя добавить групповую услугу
      if(this.servicesModel.length && +val.is_group === 1){
        this.$store.dispatch("addNotification", {
            text: "В обычной записи не может быть групповой услуги",
            time: 3,
            color: "danger"
          });
          return false;
      }

      this.servicesModel.push(val);

      let is_group = 0;
      for (let key in this.servicesModel) {
        if(+this.servicesModel[key].is_group === 1){
          is_group = 1;
        }
      }
      this.is_group = is_group;
    },
    deleteService(serviceId, modificationId) {
      for (let key in this.servicesModel) {
        if (+this.servicesModel[key].service_id === +serviceId && +this.servicesModel[key].modification_id === +modificationId) {
          this.$delete(this.servicesModel, key);
        }
      }

      let is_group = 0;
      for (let key in this.servicesModel) {
        if(+this.servicesModel[key].is_group === 1){
          is_group = 1;
        }
      }
      this.is_group = is_group;
    },
    getStaffData() {
      this.$store.dispatch("startPreloader");

      staffRepository.getStaffWithActiveDays().then(resp => {
        this.fullData.staff = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    showWindows() {
      if (this.staffModel == "") {
        this.$store.dispatch("addNotification", {
          text: "Не выбран сотрудник",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (this.dateModel == "") {
        this.$store.dispatch("addNotification", {
          text: "Не выбрана дата",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (!this.servicesModel.length) {
        this.$store.dispatch("addNotification", {
          text: "Не выбрана ни одна услуга",
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.$store.dispatch("startPreloader");
      const request = {
        'staff': this.staffModel,
        'duration': this.servicesDurationMinute,
        'confirm_future_enroll': this.enrollConfirm,
        'selected_services': this.selectedServices
      };

      if (this.mode == "edit" && this.loadEnrollId > 0) {
        request.exclude_enroll = this.loadEnrollId;
      }
      let dateJSObj = formatter.rusDateToJSObject(this.dateModel);
      let datePhpFormat = formatter.dateToPhpFormat(dateJSObj);
      request.date = datePhpFormat;

      journalRepository.getIntervalsByDate(request).then(resp => {
        this.timeIntervals = resp.data;
        if (this.timeIntervals.length) {
          if (this.computedWantTime === 0 && this.mode == "new") {
            this.timeModel = this.timeIntervals[0].from;
          } else {
            let foundRes = false;
            for (let key in this.timeIntervals) {
              if (+this.timeIntervals[key].from === +this.wantTime) {
                foundRes = true;
              }
            }
            if (foundRes) {
              this.timeModel = this.wantTime;
            } else {
              this.timeModel = "";
            }
          }
        } else {
          this.$store.dispatch("addNotification", {
            text: "Нет свободных интервалов для записи",
            time: 3,
            color: "danger"
          });
          this.timeModel = "";
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    saveEnroll(andClose = false) {
      if (this.validateCommentCompany) {
        return false;
      }
      if (this.staffModel == "") {
        this.$store.dispatch("addNotification", {
          text: "Не выбран сотрудник",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (this.dateModel == "") {
        this.$store.dispatch("addNotification", {
          text: "Не выбрана дата",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (!this.servicesModel.length) {
        this.$store.dispatch("addNotification", {
          text: "Не выбрана ни одна услуга",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (this.timeModel === "") {
        this.$store.dispatch("addNotification", {
          text: "Не выбрано время",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (
        this.enrollClientsModel.length > 0 &&
        !this.enrollClientsModel[0].clients &&
        +this.is_group === 0
      ) {
        this.$store.dispatch("addNotification", {
          text: "Не выбран клиент",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if(this.fullConfig.company_config &&
          this.fullConfig.company_config.add_field == 1 &&
          this.fullConfig.company_config.add_field_required == 1 &&
          this.addField === '')
      {
        this.$store.dispatch("addNotification", {
          text: `Не заполнено поле "${this.fullConfig.company_config.add_field_name}"`,
          time: 3,
          color: "danger"
        });
        return false;
      }

      let formData = new FormData();
      let data = {
        remind_before_hour: this.remindHourModel,
        comment_company: this.enrollComment,
        confirm: this.enrollConfirm,
        staff: this.staffModel,
        exclude_enroll_old_today: false,
        source_client_id: this.source_client_id,
        is_group: this.is_group
      };
      //formData.append("remind_before_hour", this.remindHourModel);
      //formData.append("comment_company", this.enrollComment);
      //formData.append("confirm", this.enrollConfirm);
      //formData.append("staff", this.staffModel);
      //formData.append("exclude_enroll_old_today", false);
      //formData.append("source_client_id", this.source_client_id);
      //formData.append("is_group", this.is_group);

      if(+this.is_group === 0){
        //formData.append('send_sms_client', this.sendSms);
        data.send_sms_client = this.sendSms;
        //formData.append('send_telegram_client', this.sendTelegram ? 1 : 0);
        data.send_telegram_client = this.sendTelegram ? 1 : 0;
        //formData.append('send_whatsapp_client', this.sendWhatsapp ? 1 : 0);
        data.send_whatsapp_client = this.sendWhatsapp ? 1 : 0;
        //formData.append('send_email_client', this.sendEmail ? 1 : 0);
        data.send_email_client = this.sendEmail ? 1 : 0;
      }else{
        //formData.append('send_edit_notify_group', this.send_edit_notify_group);
        data.send_edit_notify_group = this.send_edit_notify_group;
        // formData.append(
        //   'group_setting[participants_count]',
        //   this.groupSetting.participants_count
        // );
        data.group_setting = {
          participants_count: this.groupSetting.participants_count,
          show_seats_left: this.groupSetting.show_seats_left ? 1 : 0,
          notifications_new: this.groupSetting.notifications_new ? 1 : 0,
        };
        // formData.append(
        //   'group_setting[show_seats_left]',
        //   this.groupSetting.show_seats_left ? 1 : 0
        // );
        // formData.append(
        //   'group_setting[notifications_new]',
        //   this.groupSetting.notifications_new ? 1 : 0
        // );
      }

      let dateJSObj = formatter.rusDateToJSObject(this.dateModel);
      // formData.append("date", datePhpFormat);
      // formData.append("time", this.timeModel);
      data.date = formatter.dateToPhpFormat(dateJSObj);
      data.time = this.timeModel;

      data.services = [];
      for(let servKey in this.servicesModel){
        const service = {
          service_id: this.servicesModel[servKey]['service_id'],
          modification_id: this.servicesModel[servKey]['modification_id'],
          category_name: this.servicesModel[servKey]['category_name'],
          name: this.servicesModel[servKey]['name'],
          price: this.servicesModel[servKey]['price'],
          time_hour: this.servicesModel[servKey]['time_hour'],
          time_minute: this.servicesModel[servKey]['time_minute'],
        };
        data.services.push(service);
        //let formKey = 'services[' +servKey +']';
        //formData.append(formKey +'[service_id]', this.servicesModel[servKey]['service_id']);
        //formData.append(formKey +'[modification_id]', this.servicesModel[servKey]['modification_id']);
        //formData.append(formKey +'[category_name]', this.servicesModel[servKey]['category_name']);
        //formData.append(formKey +'[name]', this.servicesModel[servKey]['name']);
        //formData.append(formKey +'[price]', this.servicesModel[servKey]['price']);
        //formData.append(formKey +'[time_hour]', this.servicesModel[servKey]['time_hour']);
        //formData.append(formKey +'[time_minute]', this.servicesModel[servKey]['time_minute']);
      }

      // Установим клиентов
      if(
        this.enrollClientsModel.length > 0 &&
        this.enrollClientsModel[0].clients
      ){
        data.enroll_clients = [];
        for(let ecKey in this.enrollClientsModel){
          if(this.enrollClientsModel[ecKey].clients){
            let client = {};
            //let formKey = 'enroll_clients[' +ecKey +']';
            if(this.enrollClientsModel[ecKey]['add_field']){
              //formData.append(formKey +'[add_field]', this.enrollClientsModel[ecKey]['add_field']);
              client.add_field = this.enrollClientsModel[ecKey]['add_field'];
            }else{
              //formData.append(formKey +'[add_field]', '');
              client.add_field = '';
            }

            //formData.append(formKey +'[client_modification_id]', this.enrollClientsModel[ecKey]['client_modification_id']);
            client.client_modification_id = this.enrollClientsModel[ecKey]['client_modification_id'];

            if(this.enrollClientsModel[ecKey]['comment']){
              //formData.append(formKey +'[comment]', this.enrollClientsModel[ecKey]['comment']);
              client.comment = this.enrollClientsModel[ecKey]['comment'];
            }else{
              //formData.append(formKey +'[comment]', '');
              client.comment = '';
            }

            //formData.append(formKey +'[number]', this.enrollClientsModel[ecKey]['clients']['number']);
            client.number = this.enrollClientsModel[ecKey]['clients']['number'];

            if(+this.is_group === 0){
              //formData.append(formKey +'[is_canceled]', this.isCanceledForFastClient);
              client.is_canceled = this.isCanceledForFastClient;

              if(this.isCanceledForFastClient === 1){
                //formData.append(formKey +'[cancel_reason]', this.enrollClientsModel[ecKey]['cancel_reason']);
                client.cancel_reason = this.enrollClientsModel[ecKey]['cancel_reason'];
              }else{
                //formData.append(formKey +'[cancel_reason]', '');
                client.cancel_reason = '';
              }
            }else{
              //formData.append(formKey +'[is_canceled]', this.enrollClientsModel[ecKey]['is_canceled']);
              client.is_canceled = this.enrollClientsModel[ecKey]['is_canceled'];
              //formData.append(formKey +'[cancel_reason]', this.enrollClientsModel[ecKey]['cancel_reason']);
              client.cancel_reason = this.enrollClientsModel[ecKey]['cancel_reason'];
            }
            data.enroll_clients.push(client);
          }
        }
      }

      //let urlAction = "";
      let method = '';
      if (this.mode === "edit" && this.loadEnrollId > 0) {
        //formData.append("update_enroll_id", this.loadEnrollId);
        data.update_enroll_id = this.loadEnrollId;
        method = 'updateEnroll';
        //urlAction = "/enroll/update-enroll";
      } else {
        //urlAction = "/enroll/set-enroll";
        method = 'setEnroll';
      }

      this.$store.dispatch("startPreloader");

      enrollRepository[method](data).then(resp => {
        if (resp.data.result === "ok") {
          this.$store.dispatch("addNotification", {
            text: "Успешно",
            time: 3,
            color: "success"
          });
        }
        this.$emit("updateLoadEnroll", +resp.data.id);
        this.$emit("updateWantTime", +this.timeModel);
        if(andClose){
          this.$emit("close");
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        if (err.response.data["error-info"] == -2) {
          this.$store.dispatch("addNotification", {
            text:
                "Похоже, что продолжительность услуг не вмещается в окно. Обновите доступное время",
            time: 6,
            color: "danger"
          });
        } else {
          this.$store.dispatch("addNotification", {
            text: err.response.data.message,
            time: 6,
            color: "danger"
          });
        }
        this.$store.dispatch("stopPreloader");
      });

      // axios
      //   .post(urlAction, formData)
      //   .then(resp => {
      //     if (resp.data.result == "ok") {
      //       this.$store.dispatch("addNotification", {
      //         text: "Успешно",
      //         time: 3,
      //         color: "success"
      //       });
      //     }
      //     this.$emit("updateLoadEnroll", +resp.data.id);
      //     this.$emit("updateWantTime", +this.timeModel);
      //     // if(!andClose){
      //     //   this.loadEnroll(resp.data.id);
      //     // }
      //     if(andClose){
      //       this.$emit("close");
      //     }
      //     this.$store.dispatch("stopPreloader");
      //   })
      //   .catch(err => {
      //     if (err.response.data["error-info"] == -2) {
      //       this.$store.dispatch("addNotification", {
      //         text:
      //           "Похоже, что продолжительность услуг не вмещается в окно. Обновите доступное время",
      //         time: 6,
      //         color: "danger"
      //       });
      //     } else {
      //       this.$store.dispatch("addNotification", {
      //         text: err.response.data.message,
      //         time: 6,
      //         color: "danger"
      //       });
      //     }
      //     this.$store.dispatch("stopPreloader");
      //   });
    },
    prepareServicesListData(data) {
      let result = [];
      for (let key in data) {
        let row = {};
        if(+data[key].modification_id > 0){
          row.id = data[key].modification_id;
        }else{
          row.id = data[key].service_id;
        }
        row.service_id = data[key].service_id;
        row.modification_id = data[key].modification_id;
        row.name = data[key].service_name;
        row.category_name = data[key].category_name;
        let smashHM = formatter.minuteSplitHourMinute(data[key].duration);
        row.time_hour = smashHM.hour;
        row.time_minute = smashHM.minute;
        row.price = data[key].price;
        row.addPlace = 'server';
        result.push(row);
      }
      return result;
    },
    loadEnroll(id) {
      this.$store.dispatch("startPreloader");

      enrollRepository.getById({
        'id': id
      }).then(resp => {
        this.remindHourSetter = +resp.data.remind_before_hour;
        this.enrollClients = resp.data.enrollClients;
        this.is_group = resp.data.is_group;
        if(resp.data.enrollGroupParams){
          this.groupSetting.participants_count = +resp.data.enrollGroupParams.participants_count;
          this.groupSetting.show_seats_left = +resp.data.enrollGroupParams.show_seats_left;
          this.groupSetting.notifications_new = +resp.data.enrollGroupParams.notifications_new;
        }
        this.searchClientSelected = resp.data.clients;
        this.staffModel = resp.data.staff_id;
        this.staffEnroll = resp.data.staff_id;
        this.servicesModel = this.prepareServicesListData(
            resp.data.enrollPosition
        );
        this.enrollConfirm = resp.data.confirm;
        if (resp.data.comments) {
          this.enrollComment = resp.data.comments.comment_company?resp.data.comments.comment_company:"";
        }else{
          this.enrollComment = "";
        }
        this.enrollHistory = resp.data.enrollHistory;
        this.timeModel = resp.data.time;
        this.date_google_from = resp.data.date_google_from;
        this.date_google_to = resp.data.date_google_to;
        this.source_client_id = resp.data.source_client_id;
        this.source_client_enroll = resp.data.sourceClient;
        this.manual_sms_text = resp.data.manual_sms_text;
        this.timeIntervals = [];
        let intervalVariant = {};
        intervalVariant.from = resp.data.time;
        this.timeIntervals.push(intervalVariant);

        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    websocketSaveEnrollObserve(data) {
      if (+data.data.id === +this.loadEnrollId) {
        this.loadEnroll(this.loadEnrollId);
      }
    },
    websocketDeleteEnrollObserve(data) {
      if (+data.data.id === +this.loadEnrollId) {
        this.$emit("closeAndUpdate");
        this.closeDeleteEnrollPopup();
      }
    },
  },
  created() {
    websocketEventBus.subscribeToSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.subscribeToDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
  beforeDestroy() {
    websocketEventBus.unsubscribeFromSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.unsubscribeFromDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
};
</script>

<style scoped lang="less">
.new-fast--staff-line {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  .new-fast--staff {
    width: 48%;
  }
  .new-fast--date {
    width: 48%;
  }
  .new-fast--intervals {
    width: 24%;
  }
}
.new-fast--intervals-line {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  flex-direction: row;

  .new-fast--load-intervals {
    text-align: right;
    width: 50%;
  }
  .new-fast--intervals {
    width: 50%;
  }
}
.duration-flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  flex-direction: row;

  & > div:nth-of-type(1) {
    width: 46%;
  }
  & > div:nth-of-type(2) {
    width: 5%;
    text-align: center;
    line-height: 30px;
  }
  & > div:nth-of-type(3) {
    width: 46%;
  }
}
.new-fast--services-item-title {
  font-size: 12px;
  color: gray;
}
.new-fast--services-list {
  .new-fast--services-item-item, .new-fast--services-item-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;
    margin-top: 5px;

    .name {
      width: 50%;
    }
    .duration {
      width: 20%;
    }
    .price {
      width: 20%;
    }
    .actions {
      width: 10%;
    }
  }
}

.new-fast--status-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;

  & > .item {
    width: 140px;
    position: relative;
    padding: 10px;
    border: 1px solid rgb(202, 202, 202);
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    margin-top: 8px;

    .name{
      color: rgb(172, 172, 172);
      font-size: 13px;
    }
    .color{
      position: absolute;
      top: 3px;
      right: 3px;
      opacity: 0.5;
    }
  }
  & > .item.active{
    border: 1px solid #333;
    background-color: rgba(248, 248, 248, 0);

    .name{
      color: #333;
      font-weight: 700;
      text-decoration: underline;
    }
    .color{
      opacity: 1;
    }
  }
}
.circle-status {
  display: inline-block;
  width: 17px;
  height: 17px;
  border-radius: 15px;
}
.circle-status-new {
  background-color: #ff3d3d;
}
.circle-status-confirm {
  background-color: #fecf63;
}
.circle-status-done {
  background-color: #36deac;
}
.circle-status-cancel {
  background-color: #6f03d3;
}
.new-fast--actions {
  text-align: right;
}

.new-fast--addfield-line-text{
  box-sizing: border-box;

  .text{
    padding: 4px 4px 4px 8px;
    border-left: 2px solid #F97979;
    font-style: italic;
  }

  .title{
    font-size: 15px;
    font-weight: 700;
  }
}
.full-price{
  margin-top: 15px;
  font-size: 16px;
  text-align: right;
  text-decoration: underline;
}
.minimal_enroll_sum{
  font-size: 12px;
}
.add-source{
  margin-top: 4px;
  font-size: 12px;
  text-decoration: underline dashed #0693e3;
  cursor: pointer;
  color: #0693e3;
}
@media (max-width: 600px) {
  .new-fast--services-list {
    .new-fast--services-item-title {
      display: none;
    }
  }
  .new-fast--services-list {
    .new-fast--services-item-item {
      position: relative;
      flex-wrap: wrap;
      margin-top: 20px;

      .name {
        width: 100%;
        margin-bottom: 8px;
      }
      .duration {
        width: 47%;
      }
      .price {
        width: 32%;
      }
      .actions {
        width: 13%;
      }
    }
    .new-fast--services-item-item:not(:last-child):after {
      content: "";
      display: block;
      width: 100px;
      height: 1px;
      margin: 0 auto;
      border-top: 1px solid #d0d0d0;
      position: absolute;
      bottom: -10px;
    }
  }
}

@media (max-width: 600px) {
  .new-fast--client-line{
    .client-line--flex{
      flex-wrap: wrap;
    }
  }
}
</style>
